import './ListHeader.scss'

interface ListHeaderProps {
  title: string
  isMobile: boolean
  extraChildren?: React.ReactNode
}

function ListHeader({ title, isMobile, extraChildren }: ListHeaderProps) {
  return (
    <div
      className={`list-header ${isMobile ? 'list-header-mobile' : ''} ${extraChildren ? 'list-header-with-children' : ''}`}
    >
      <span className="list-header-text">{title ? title : 'Otros'}</span>
      {extraChildren}
    </div>
  )
}

export default ListHeader
